import ScrollStick from '../util/scroll-stick';

class StickyContentCards {
	constructor(el) {
		this.stickyEl = el.querySelector('.js-sticky-content-cards-sticky');
		this.sidebarEl = el.querySelector('.block-sticky-content-cards__sidebar');
		this.headerEl = document.querySelector('header');
		this.stickyGap = 40;

		this.updateSticky();

		window.addEventListener('resize', () => {
			this.updateSticky();
		});

		if (this.headerEl && 'ResizeObserver' in window) {
			this.headerResizeObserver = new ResizeObserver(() => {
				this.updateStickyOffset();
			});

			this.headerResizeObserver.observe(this.headerEl);
		}

		if (this.stickyEl && 'ResizeObserver' in window) {
			this.stickyResizeObserver = new ResizeObserver(() => {
				this.updateSidebarHeight();
			});

			this.stickyResizeObserver.observe(this.stickyEl);
		}
	}

	getStickyTopOffset() {
		if (!this.headerEl) {
			return this.stickyGap;
		}

		const headerHeight = this.headerEl.getBoundingClientRect().height;

		return Math.ceil(headerHeight + this.stickyGap);
	}

	updateSidebarHeight() {
		if (!this.sidebarEl || !this.stickyEl) {
			return;
		}

		if (!window.matchMedia('(min-width: 1025px)').matches) {
			this.sidebarEl.style.minHeight = '';
			return;
		}

		this.sidebarEl.style.minHeight = `${Math.ceil(this.stickyEl.getBoundingClientRect().height)}px`;
	}

	updateStickyOffset() {
		if (!this.scrollStick) {
			return;
		}

		this.scrollStick.setTopTriggerOffset(
			this.getStickyTopOffset()
		);
	}

	updateSticky() {
		if (!this.stickyEl) {
			return;
		}

		if (!window.matchMedia('(min-width: 1025px)').matches) {
			this.scrollStick?.disable();
			this.updateSidebarHeight();
			return;
		}

		this.updateSidebarHeight();

		const topTriggerOffset = this.getStickyTopOffset();

		if (this.scrollStick) {
			this.scrollStick.setTopTriggerOffset(topTriggerOffset);
			this.scrollStick.enable();
			return;
		}

		this.scrollStick = new ScrollStick(
			this.stickyEl,
			topTriggerOffset
		);
	}
}

export default StickyContentCards;
